import {AxiosRequestConfig} from 'axios'
import RequestBase from '../../../api/RequestBase'

function acknowledgmentToken(payload: any, config?: AxiosRequestConfig | undefined) {
  return RequestBase.post(`/policy/acknowledgment`, payload, config)
}

function getPolicyAcceptanceUPic(config?: AxiosRequestConfig | undefined) {
  return RequestBase.get(`/policy/terms-upic`, config)
}

function acceptTermsUPic(payload: any, config?: AxiosRequestConfig | undefined) {
  return RequestBase.post(`/policy/terms-upic`, payload, config)
}

const OptService = {
  acknowledgmentToken,
  getPolicyAcceptanceUPic,
  acceptTermsUPic,
}

export default OptService
